module.exports = __webpack_public_path__ + "img/login_bg_1.5eea3e05.png";